import { ScimProvisioningType } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { FormSelectionCardGroupField, LocalizedText } from '@mews/framework';
import { ConfigureScimFieldNames } from '../useConfigureScimForm';

const options = [
    {
        label: <LocalizedText textKey={TextKey.MicrosoftAzure} />,
        value: ScimProvisioningType.Azure,
        name: ScimProvisioningType.Azure,
    },
];

export const ScimProviderSelectionCardGroupField = () => (
    <FormSelectionCardGroupField name={ConfigureScimFieldNames.ProvisioningProvider} type="radio" options={options} />
);
